/**
 * DescriptionTip component.
 */
import Container from '@components/atoms/container/descriptionTipContainer';
import Tip from '@components/elements/tip/tip';

/**
 * Accessibility / hint row above the event title.
 */
export default function DescriptionTip({
  alternateTip = false,
}: {
  alternateTip?: boolean;
}) {
  return (
    <Container>
      <Tip alternateTip={alternateTip} />
    </Container>
  );
}
